import { Strings } from '@app/constants';
import { ProfileCard } from '@app/components/card';
import { IAddClientSchema } from '../types';

interface Props {
  clientData: IAddClientSchema;
}

export const ClientProfile = ({ clientData }: Props) => {
  const status = clientData?.status ? 'Active' : 'Inactive';
  const fields = [
    Strings.field.firstName,
    Strings.field.lastName,
    Strings.field.phone,
    Strings.field.email,
    Strings.field.companyName,
    Strings.field.status,
  ];
  const data = [
    clientData?.firstName ? clientData.firstName : 'NA',
    clientData?.lastName ? clientData.lastName : 'NA',
    clientData?.phone ? clientData.phone : 'NA',
    clientData?.email ? clientData.email : 'NA',
    clientData?.companyName ? clientData.companyName : 'NA',
    status || 'NA',
  ];
  return (
    <ProfileCard
      fields={fields}
      data={data}
      Src={
        clientData?.image ? clientData?.image : `${clientData?.firstName} ${clientData?.lastName}`
      }
      title={Strings.profile.personalInformation}
    />
  );
};
